import { ledgerRoutes } from "./Ledger";
import { serviceOrderRoutes } from "./ServiceOrder";
import { serviceRequesitionRoutes } from "./ServiceRequesition";
import { internalStoreTransferRoutes } from "./grn";

export const appModuleRoutes = [...serviceRequesitionRoutes]
  .concat(serviceOrderRoutes)
  .concat(ledgerRoutes)
  .concat(internalStoreTransferRoutes);
